(function (root) {
  'use strict';
  if (root.CurrenhausCompatibilityAnalytics) return;
  // Existing storefront Google pixel destination; do not install/configure another tag.
  const destination = 'G-W9B7XR78KX';
  const names = new Set(['compatibility_opened', 'compatibility_checked', 'compatibility_machine_saved', 'compatibility_help_clicked']);
  const statuses = new Set(['compatible', 'attachment_needs_confirmation', 'machine_type_mismatch', 'outside_recommended_power_range', 'verify_hydraulic_output', 'verify_power_requirements', 'configuration_required']);
  const types = new Set(['Tractor', 'Skid Steer', 'Excavator', 'Mini Skid Steer']);
  const handled = new WeakMap();
  try {
    if (!root.Shopify?.customerPrivacy && typeof root.Shopify?.loadFeatures === 'function') {
      root.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {});
    }
  } catch (_) { /* Analytics must never affect shopping. */ }
  function emit(selector, name, interaction, resultStatus, machineType) {
    try {
      if (!names.has(name) || !interaction?.isTrusted) return false;
      let eventNames = handled.get(interaction);
      if (!eventNames) { eventNames = new Set(); handled.set(interaction, eventNames); }
      if (eventNames.has(name)) return false;
      eventNames.add(name);
      // Fail closed; never replay pre-consent interactions after consent is granted.
      if (root.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() !== true || typeof root.gtag !== 'function') return false;
      const productId = selector.dataset.productId, variantId = selector.variantId();
      if (!/^\d+$/.test(productId || '') || !/^\d+$/.test(variantId || '')) return false;
      const url = new URL(selector.dataset.productUrl, root.location.origin);
      if (url.origin !== root.location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/[a-z0-9-]+\/?$/i.test(url.pathname)) return false;
      const environment = selector.dataset.analyticsEnvironment === 'production' && !root.Shopify?.designMode && !new URLSearchParams(root.location.search).has('preview_theme_id') ? 'production' : 'draft';
      const payload = {
        send_to: destination,
        product_id: String(productId),
        variant_id: String(variantId),
        page_path: url.pathname,
        // Override automatic URL/title/referrer enrichment: no query strings or customer text.
        page_location: url.origin + url.pathname,
        page_referrer: '',
        page_title: 'Machine compatibility',
        tracking_environment: environment,
        compatibility_event: name
      };
      if (name === 'compatibility_checked') {
        if (!statuses.has(resultStatus) || !types.has(machineType)) return false;
        payload.machine_type = machineType;
        payload.result_status = resultStatus;
      }
      if (name === 'compatibility_machine_saved') {
        if (!types.has(machineType) || selector.store?.persistent?.() !== true) return false;
        payload.machine_type = machineType;
        payload.save_scope = 'browser';
        payload.selection_method = 'catalog_configuration';
      }
      if (name === 'compatibility_machine_saved' || name === 'compatibility_checked') {
        // Resolve labels from the loaded catalog, never from customer-entered or saved text.
        const selected = selector.selection;
        const machine = selector.data?.models?.find(record => record.id === selected?.machine?.id);
        const configuration = machine?.configurations?.find(record => record.id === selected?.configuration?.id);
        if (configuration && /^\d+$/.test(machine.id) && /^\d+$/.test(configuration.id)) {
          payload.machine_id = String(machine.id);
          payload.configuration_id = String(configuration.id);
          for (const [key, value] of [['machine_make', machine.manufacturer], ['machine_model', machine.model], ['machine_configuration', configuration.name]]) {
            // Bound catalog labels to the event parameter length; IDs retain exact identity.
            if (typeof value === 'string' && value.trim()) payload[key] = Array.from(value.trim()).slice(0, 100).join('');
          }
        }
      }
      if (environment === 'draft') payload.debug_mode = true;
      const sent = root.gtag('event', environment === 'draft' ? 'draft_' + name : name, payload);
      if (sent && typeof sent.catch === 'function') sent.catch(function () {});
      return true; // Handed to the existing tag, not confirmation of GA4 receipt.
    } catch (_) { return false; }
  }
  root.CurrenhausCompatibilityAnalytics = { emit };
})(window);
